import ExportIcon from "../../assets/svg/ExportIcon";

const DownloadCSV = ({ data, fileName, disabled = false }) => {
  const convertToCSV = (objArray) => {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    // Add BOM for proper UTF-8 encoding
    str = "\uFEFF";

    // Add headers from object keys with proper escaping
    if (array.length > 0) {
      const headers = Object.keys(array[0]);
      // Make headers uppercase for visual distinction
      const formattedHeaders = headers.map(
        (header) => `"${header.toUpperCase()}"`
      );
      str += formattedHeaders.join(",") + "\r\n";
    }

    // Add data rows with proper escaping
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";
        // Escape values that contain commas, quotes, or newlines
        let value = array[i][index];
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes('"') || value.includes("\n"))
        ) {
          value = `"${value.replace(/"/g, '""')}"`;
        }
        line += value;
      }
      str += line + "\r\n";
    }
    return str;
  };

  const downloadCSV = () => {
    if (disabled || !data || data.length === 0) return;

    const csvData = new Blob([convertToCSV(data)], { type: "text/csv" });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <button
      onClick={downloadCSV}
      disabled={disabled || !data || data.length === 0}
      className={`border rounded-lg px-2 py-1 flex gap-1 items-center transition-all duration-200 ${
        disabled || !data || data.length === 0
          ? "bg-gray-400 text-white cursor-not-allowed opacity-100"
          : "bg-gray-500 text-white hover:bg-gray-600 cursor-pointer"
      }`}
    >
      <span>
        {" "}
        <ExportIcon className={"w-5 h-6 delay-300"} />{" "}
      </span>
      <span>Export</span>
    </button>
  );
};

export default DownloadCSV;
